import React, { memo } from "react";
import { Box, Typography, useTheme } from "@material-ui/core";
import { selectionYellow, emptyListTextColor } from "styles/colors";

const EmptyPlaceholderList = ({ label = "" }) => {
    const theme = useTheme();

    return (
        <Box
            p={2}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            borderRadius={`${theme.spacing(0.5)}px`}
            py={`${theme.spacing(8)}px`}
            my={`${theme.spacing(1)}px`}
            style={{ backgroundColor: selectionYellow, color: emptyListTextColor }}>
            <Typography variant="body1">{label}</Typography>
        </Box>
    );
};

export default memo(EmptyPlaceholderList);
